import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import user4 from "../../assets/images/default.png";
import {
  Form,
  FormControl as Input,
  InputGroup,
  Button,
} from "react-bootstrap";
import { Attention } from "../../component/base/Attention";
import PasswordInput from "../../component/base/PasswordInput";
import { STORAGE_URL } from "../../constants/consts";
import { SaveRounded } from "@mui/icons-material";
import { MdLogout } from "react-icons/md";
import { useLogout } from "../../hooks/useLogout";
import Swal from "sweetalert2";

export default function EditProfileView() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [avatar, setAvatar] = useState(user4);
  const [avatarBase64, setAvatarBase64] = useState(null);
  
  // Loading states
  const [isLoadingScreen, setIsLoadingScreen] = useState(true);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  
  // Message states
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');  const me = useSelector((store) => store.auth.me);
  const logout = useLogout();

  // Initialize form data with user information
  useEffect(() => {
    if (me) {
      setName(me.name || '');
      setEmail(me.email || '');
      setIsLoadingScreen(false);
    }
  }, [me]);

  const validateForm = () => {
    if (!name.trim()) {
      setErrorMessage('Nome é obrigatório');
      return false;
    }
    
    if (password && password !== passwordConfirmation) {
      setErrorMessage('Senhas não coincidem');
      return false;
    }
    
    if (password && password.length < 6) {
      setErrorMessage('Senha deve ter pelo menos 6 caracteres');
      return false;
    }
    
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsLoadingSave(true);
    setErrorMessage('');
    setSuccessMessage('');
    
    try {
      // TODO: Implement API call to update profile
      // const formData = new FormData();
      // formData.append('name', name);
      // if (password) formData.append('password', password);
      // if (avatar instanceof File) formData.append('avatar', avatar);
      
      setSuccessMessage('Perfil atualizado com sucesso!');
    } catch (error) {
      setErrorMessage('Erro ao atualizar perfil. Tente novamente.');
    } finally {
      setIsLoadingSave(false);
    }
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    
    if (!file) return;
    
    // Validate file type and size
    if (!file.type.startsWith('image/')) {
      setErrorMessage('Arquivo deve ser uma imagem');
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) { // 5MB limit
      setErrorMessage('Imagem deve ter menos de 5MB');
      return;
    }
    
    setIsLoadingImage(true);
    setAvatar(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      setAvatarBase64(e.target.result);
      setIsLoadingImage(false);
    };
    reader.onerror = () => {
      setErrorMessage('Erro ao carregar imagem');
      setIsLoadingImage(false);
    };
    reader.readAsDataURL(file);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Tem certeza que deseja trocar de conta?",
      text: "Você será redirecionado para a página de login",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#70747c",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, trocar!",
      cancelButtonText: "Cancelar",    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  const clearSuccessMessage = () => setSuccessMessage('');
  const clearErrorMessage = () => setErrorMessage('');

  const getUserAvatarSrc = () => {
    if (me?.image && me.image !== "") {
      return STORAGE_URL + me.image;
    }
    return avatarBase64 || avatar;
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="py-5 px-3">
          <div className="card-body" id="card">
            {/* Profile banner and avatar section */}
            <div
              style={{
                display: "flex",
                position: "relative",
                marginBottom: "5rem",
              }}
            >
              <img
                src="https://picsum.photos/1400/300"
                alt="Banner do perfil"
                style={{
                  width: "100%",
                  height: "16rem",
                  objectFit: "cover",
                  borderRadius: "0.6rem",
                  border: "0.1rem solid #ccc",
                }}
              />
              <label
                htmlFor="avatar"
                style={{
                  cursor: "pointer",
                  width: "14rem",
                  aspectRatio: "1/1",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  position: "absolute",
                  bottom: "-3rem",
                  left: "1.4rem",
                  border: "0.3rem solid white",
                  overflow: "hidden",
                }}
              >
                <img
                  src={getUserAvatarSrc()}
                  alt="Usuário"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <input
                  type="file"
                  name="avatar"
                  id="avatar"
                  style={{ display: "none" }}
                  onChange={handleAvatarChange}
                  accept="image/*"
                />
              </label>
            </div>

            {!isLoadingScreen ? (
              <div>
                {/* Success message */}
                {successMessage && (
                  <div style={{ display: "flex", marginBottom: 15, width: "100%" }}>
                    <div className="alert alert-success alert-dismissible fade show mb-0 w-100" role="alert">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={clearSuccessMessage}
                      ></button>
                      <p style={{ marginBottom: 0, whiteSpace: "pre" }}>
                        {successMessage}
                      </p>
                    </div>
                  </div>
                )}

                {/* Error message */}
                {errorMessage && (
                  <div style={{ display: "flex", marginBottom: 15, width: "100%" }}>
                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={clearErrorMessage}
                      ></button>
                      <p style={{ marginBottom: 0 }}>{errorMessage}</p>
                    </div>
                  </div>
                )}

                <Form
                  onSubmit={onSubmit}
                  style={{
                    position: "relative",
                    gap: "1rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Name and Email row */}
                  <div className="row">
                    <InputGroup className="col-lg">
                      <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>
                          Nome <Attention />
                        </Form.Label>
                        <Input
                          placeholder="Nome"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </InputGroup>

                    <InputGroup className="col-lg">
                      <div className="flex fdcolumn flex1 margin-bottom">
                        <Form.Label>
                          E-mail <Attention />
                        </Form.Label>
                        <Input
                          disabled
                          placeholder="E-mail"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </InputGroup>
                  </div>

                  {/* Password fields row */}
                  <div className="row">
                    <InputGroup className="col-lg">
                      <PasswordInput
                        label="Senha"
                        placeholder="Digite sua nova senha (opcional)"
                        className="flex1"
                        value={password}
                        OnChangeText={(e) => setPassword(e.target.value)}
                      />
                    </InputGroup>

                    <InputGroup className="col-lg">
                      <PasswordInput
                        label="Confirmação de senha"
                        placeholder="Confirme sua nova senha"
                        className="flex1"
                        value={passwordConfirmation}
                        OnChangeText={(e) => setPasswordConfirmation(e.target.value)}
                      />
                    </InputGroup>
                  </div>

                  {/* Action buttons */}
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="secondary"
                      disabled={isLoadingImage}
                      className="flex align-center jcc"
                      onClick={handleLogout}
                    >
                      <MdLogout style={{ fontSize: '1.4rem', marginRight: 10 }} /> 
                      Trocar de conta
                    </Button>
                    
                    <Button
                      variant="success"
                      type="submit"
                      disabled={isLoadingImage || isLoadingSave}
                      className="flex align-center jcc"
                    >
                      <SaveRounded style={{ marginRight: 10 }} /> 
                      {isLoadingSave ? 'Salvando...' : 'Salvar'}
                    </Button>
                  </div>

                  {/* Loading indicator for save action */}
                  {isLoadingSave && (
                    <div className="row">
                      <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                        <div className="spinner-border text-primary" role="status"></div>
                      </div>
                    </div>
                  )}
                </Form>
              </div>
            ) : (
              // Loading screen
              <div className="row">
                <div
                  className="col-12 d-flex justify-content-center align-items-center"
                  style={{ marginTop: "2rem" }}
                >
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
